import { render, staticRenderFns } from "./BrandPermissions.vue?vue&type=template&id=2852bdd4&scoped=true&"
import script from "./BrandPermissions.vue?vue&type=script&lang=js&"
export * from "./BrandPermissions.vue?vue&type=script&lang=js&"
import style0 from "./BrandPermissions.vue?vue&type=style&index=0&id=2852bdd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852bdd4",
  null
  
)

export default component.exports